import { handleAllocationMethod } from 'pages/ValuationsAllocation/approaches/FutureExit/AllocationMethodTable/utils/utils';
import { SHEET_ALIASES_CONSTANTS } from 'pages/ValuationsAllocation/common/constants/futureExit';
import { parseCellValue } from 'pages/ValuationsAllocation/util';
import { getNumberValue, getObjectValue } from 'utilities';
import { CustomReverseParserParams, HandlersParams } from './types';

const handleCapTable = (params: HandlersParams) => {
  const { approach, cell, fieldAttributes } = params;
  const fieldDecimalPlaces = getNumberValue(fieldAttributes?.cap_table?.decimal_places);

  const updatedCellValue = parseCellValue({ cell, fieldDecimalPlaces });
  approach.cap_table = updatedCellValue;
};

const customReverseParser = (params: CustomReverseParserParams) => {
  const { cells, approach, fieldAttributes } = getObjectValue(params);
  const { valuations_approach_future_exit: valuationFEApproach } = getObjectValue(approach);
  const updatedFEApproach = getObjectValue(valuationFEApproach);

  const { FE_ALLOCATION_METHOD_SPREADSHEET_ALLOCATION_METHOD, FE_ALLOCATION_METHOD_SPREADSHEET_CAP_TABLE }
    = SHEET_ALIASES_CONSTANTS;

  Object.values(getObjectValue(cells)).forEach(cell => {
    const { alias } = getObjectValue(cell);

    switch (alias) {
      // Handle Allocation Method
      case FE_ALLOCATION_METHOD_SPREADSHEET_ALLOCATION_METHOD: {
        handleAllocationMethod({ approach: updatedFEApproach, cell, fieldAttributes });
        break;
      }
      // Handle Cap Table Selection
      case FE_ALLOCATION_METHOD_SPREADSHEET_CAP_TABLE: {
        handleCapTable({ approach: updatedFEApproach, cell, fieldAttributes });
        break;
      }

      default:
        break;
    }
  });
};

export default customReverseParser;
